import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import api from '../utils/api';

// A child's consultation tasks. `enrolled` distinguishes "no tasks yet" from "not in the
// consulting program" so the list can show the right empty state.
export function useConsultationTasks(studentId) {
  const [tasks, setTasks] = useState([]);
  const [enrolled, setEnrolled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const prevStudentId = useRef(studentId);

  // Clear synchronously before render when the child changes.
  useLayoutEffect(() => {
    if (prevStudentId.current !== studentId) {
      setTasks([]);
      setEnrolled(true);
      setError(null);
      setLoading(!!studentId);
      prevStudentId.current = studentId;
    }
  }, [studentId]);

  useEffect(() => {
    if (!studentId) return;

    const fetchTasks = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/parent/children/${studentId}/consultation/tasks`);
        setTasks(response.data.tasks || []);
        setEnrolled(response.data.enrolled !== false);
        setError(null);
      } catch (err) {
        // 404 → no tasks, not an error
        if (err.response?.status === 404) {
          setTasks([]);
          setError(null);
        } else {
          setError(err.response?.data?.error || 'Failed to fetch consultation tasks');
          setTasks([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [studentId]);

  return { tasks, enrolled, loading, error };
}
